import PageFrame from './Index.vue'

PageFrame.install = function(Vue) {
    Vue.component(PageFrame.name, PageFrame)
}

export default PageFrame
